function isValidName(name) {
  const isNotEmpty = name.length > 0;
  const hasNormalChars = /^[a-z ,.'-]+$/i.test(name);
  if (isNotEmpty && hasNormalChars) {
    return true;
  }
  return false;
}

function isValidPassword(password) {
  return /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d!$%@#£€*?&]{8,}$/.test(password);
}

function checkForAmountOfWords(text, amount) {
  return text && text.split(' ').length >= amount;
}

function isBase64(str) {
  try {
    return btoa(atob(str)) == str;
  } catch (err) {
    return false;
  }
}

module.exports = {
  isValidName,
  isValidPassword,
  checkForAmountOfWords,
  isBase64
};